import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 8h16v4H0V8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0h16v4H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#3D58DB"
        stroke="#fff"
        strokeWidth={1.2}
        d="M16.6 4.2v3.6H-.6V4.2h17.2Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
